// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Collapse: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M20.3 23.8h-11c-.6 0-1 .4-1 1v.7c0 .6.4 1 1 1h7.3L.6 42.4c-.4.4-.4 1 0 1.4l.5.5c.2.2.4.3.7.3.3 0 .5-.1.7-.3l15.9-15.9v7.3c0 .6.4 1 1 1h.8c.6 0 1-.4 1-1v-11c.1-.5-.3-.9-.9-.9zM44.4 1.1l-.5-.5c-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-16 15.9V9.3c0-.6-.4-1-1-1h-.8c-.6 0-1 .4-1 1v10.9c0 .6.4 1 1 1h10.9c.6 0 1-.4 1-1v-.7c0-.6-.4-1-1-1h-7.3l16-15.9c.4-.4.4-1.1.1-1.5z"/></svg>;
};

export default React.memo(Collapse);
